window.addEventListener("load", function () {
  setTimeout(() => {
    document.querySelectorAll('.rich-text-read-more-wrapper').forEach(wrapper => {
      const content = wrapper.querySelector('.read-more-content');
      const button = wrapper.querySelector('.rich-text__readmore');
      const readMoreBtn = wrapper.querySelector('.read-more-btn');
      const readLessBtn = wrapper.querySelector('.read-less-btn');
      const collapsedHeight = 230;

      if (!content || !button || !readMoreBtn || !readLessBtn) return;

      const shouldTruncate = content.scrollHeight > collapsedHeight;

      if (shouldTruncate) {
        readMoreBtn.classList.remove('hidden');

        button.addEventListener("click", () => {
          const isExpanded = button.getAttribute("aria-expanded") === "true";

          if (isExpanded) {
            content.classList.remove('expanded');
            button.setAttribute("aria-expanded", "false");
            readMoreBtn.classList.remove('hidden');
            readLessBtn.classList.add('hidden');
          } else {
            content.classList.add('expanded');
            button.setAttribute("aria-expanded", "true");
            readMoreBtn.classList.add('hidden');
            readLessBtn.classList.remove('hidden');
          }
        });
      }
    });
  }, 500);
});